import Vue                      from 'vue'
import Router                   from 'vue-router'
import StartPage                from '@/components/StartPage'
import Exponentialekvation1     from '@/components/Exponentialekvation1'
import Exponentialekvation2     from '@/components/Exponentialekvation2'
import Logik                    from '@/components/Logik'
import Kapplopning              from '@/components/Kapplopning'
import Bubbelsortering          from '@/components/Bubbelsortering'
import InfogandeSortering       from '@/components/InfogandeSortering'
import Urvalssortering          from '@/components/Urvalssortering'
import Natverksterminologi      from '@/components/Natverksterminologi'
import Tjuvochpolis             from '@/components/Tjuvochpolis'
import Montyhall                from '@/components/Montyhall'


Vue.use(Router)

export default new Router({
  routes: [
    {
        path: '/',
        name: 'StartPage',
        component: StartPage,
        fliktitel:"Startsida"
    },
    {
        path: '/kapplopning',
        name: 'Kapplopning',
        component: Kapplopning,
    },
    {
        path: '/logik',
        name: 'Logik',
        component: Logik,
        fliktitel:"Implikation och Ekvivalens"
    },
    {
        path: '/exponentialekvation1',
        name: 'Exponentialekvation1',
        component: Exponentialekvation1,
    },
    {
        path: '/exponentialekvation2',
        name: 'Exponentialekvation2',
        component: Exponentialekvation2,
    },
    {
        path: '/bubbelsortering',
        name: 'Bubbelsortering',
        component: Bubbelsortering,
        props: {
            title: "Test",
            lista: [68,45,99,12,43,48,23]
        }
    },
    {
        path: '/infogandesortering',
        name: 'InfogandeSortering',
        component: InfogandeSortering,
        props: {
            title: "Test",
            lista: [68,45,99,12,43,48,23]
        }
    },
    {
        path: '/urvalssortering',
        name: 'Urvalssortering',
        component: Urvalssortering,
        props: {
            title: "Test",
            lista: [68,45,99,12,43,48,23]
        }
    },
    {
        path: '/natverksterminologi',
        name: 'Natverksterminologi',
        component: Natverksterminologi,
        fliktitel:"Nätverksterminologi"
    },
    {
        path: '/tjuvochpolis',
        name: 'TjuvOchPolis',
        component: Tjuvochpolis,
        props: {
            xTjuv: 0,
            yTjuv: 0,
            gjordaFörsök:0
        }
    },
    {
        path: '/montyhall',
        name: 'Montyhall',
        component: Montyhall,
        fliktitel:"Monty Hall-problemet"
    }
  ]
})
